module.exports = "<div class=\"_admin-area\">\n\n  <cm-sidebar></cm-sidebar>\n  <cm-toolbar></cm-toolbar>\n\n  <main>\n\n    <v-container class=\"content-container\" fluid>\n\n      <transition name=\"fade\">\n        <router-view></router-view>\n      </transition>\n\n    </v-container>\n\n  </main>\n\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/components/views/adminArea/adminArea.vue
// module id = 365
// module chunks = 0